import { Tabs } from 'antd';

interface IPaginationTabsProps {
    tabs: string[],
    onChange: (key: string) => void,
}

const PaginationTabs = ({ tabs, onChange }: IPaginationTabsProps) => {
    return (
        <Tabs
            onChange={onChange}
            type="card"
            items={tabs.map((tab, index) => {
                return {
                    label: tab,
                    key: `${index}`,
                };
            })}
        />
    );
}

export default PaginationTabs;